import React from "react";
import "./PrivacyPolicy.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import SocialMediaPanel from "../common/social-media/SocialMediaPanel";

export default function TermCondition() {
  return (
    <>
      
       
      <main className="privacy-policy-page">
        {/* Header */}
        <header className="privacy-policy-header">
          <h1 className="privacy-policy-title">Return / Refund Policy</h1>
          <span><strong>Effective Date:</strong> 25th September 2025.</span>
        </header>

        {/* Content */}
        <section className="privacy-policy-content">
          {/* 1. General Policy */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">1. General Policy</h2>
            <ul className="privacy-policy-list">
              <li>All payments made for <strong>digital mock tests and online services are non-refundable and non-transferable.</strong></li>
              <li>Users are advised to check details carefully before making payments.</li>
            </ul>
          </article>

          {/* 2. Multiple / Duplicate Payments */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">2. Multiple / Duplicate Payments</h2>
            <ul className="privacy-policy-list">
              <li>If a user is charged multiple times due to technical errors, the excess amount will be refunded within <strong>7–10 working days</strong> after verification.</li>
            </ul>
          </article>

          {/* 3. Failed Transactions */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">3. Failed Transactions</h2>
            <ul className="privacy-policy-list">
              <li>If the payment is deducted but access is not provided, users should contact us with transaction details. The issue will be resolved within <strong>7–10 working days</strong>.</li>
            </ul>
          </article>

          {/* 4. No Cancellations */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">4. No Cancellations</h2>
            <ul className="privacy-policy-list">
              <li>Since services are digital and delivered instantly, cancellations are <strong>not allowed</strong> once access is granted.</li>
            </ul>
          </article>

          {/* 5. Contact for Refund Queries */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">5. Contact for Refund Queries</h2>
            <ul className="privacy-policy-list">
              <li> <strong> Email: </strong> <a href="mailto:support@pyqpedia.com" className="no-capitalize pyq-link"> support@pyqpedia.com</a></li>
              <li> <strong> Phone: </strong> <a href="tel:+918709364253" className="no-capitalize pyq-link"> +91 8709364253</a></li>
            </ul>
          </article>
          <p>
              <strong>This website is operated by : </strong>
              B Jha
            </p>
            <p>
              <strong>Trade Name : </strong>
              Pyq Pedia
            </p>
        </section>

        {/* Footer */}
        <footer className="privacy-policy-footer">
          <p>Issued by <strong>PYQPEDIA Team</strong></p>
        </footer>
      </main>

      
    </>
  );
}
